import React from "react";
import { HStack, Text, VStack } from "@chakra-ui/react";
import { styles } from "./TutorSubjectStyles";
import RowItem from "./RowItem";
import { motion } from "framer-motion";
import OtherActions from "./OtherActions";

const MotionVStack = motion(VStack);

const SubTopicsListing = ({ subTopics, subTopic, onClick, handleAction, topicFeatures }) => {

  return (
    <MotionVStack
      p={2}
      borderRadius={8}
      alignItems={"flex-start"}
      w={"100%"}
      bg={"white"}
      display={subTopics?.length > 0 ? "flex" : "none"}
      initial={{ opacity: 0, y: -10 }} // Animation starting point
      animate={{ opacity: 1, y: 0 }} // Animation end point
      exit={{ opacity: 0, y: -10 }} // Animation exit point
      transition={{ duration: 0.3 }} // Smooth transition duration
    >
      <Text {...styles.listingTitle}>{"Now choose your sub-topic:"}</Text>
      {subTopics?.map((subItem, subIndex) => (
        <React.Fragment key={`item-${subIndex}`}>
          <RowItem
            item={subItem?.label}
            isSelected={subTopic === subItem?.label}
            onClick={() => {
              onClick(subItem, "subTopic");
            }}
            width={"80%"}
          />
          {subItem?.label === subTopic && (
            <HStack
              spacing={[0.5, 2]}
              alignItems={["flex-start", "center"]}
              flexDirection={["column", "row"]}
            >
              <OtherActions isTopic={false} onClick={handleAction}  topicFeatures={topicFeatures}/>
            </HStack>
          )}
        </React.Fragment>
      ))}
    </MotionVStack>
  );
};

export default SubTopicsListing;
